var React = require('react');

function IcX (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"style":{"stroke":"#FFFFFF","strokeMiterlimit":"10"},"cx":"481.8","cy":"481.8","r":"481.3","key":0}),React.createElement("g",{"transform":"translate(52.390088,-25.058597)","key":1},React.createElement("path",{"id":"path1009","style":{"fill":"#FFFFFF"},"d":"M132.9,228L363,535.6L131.5,785.8h52.1l202.7-219l163.8,219h177.3l-243-324.9\n\t\t\tL699.9,228h-52.1L461.1,429.7L310.3,228H132.9z M209.6,266.4H291l359.7,481h-81.5L209.6,266.4z"}))]);
}

IcX.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 963.7 963.7","style":{"enableBackground":"new 0 0 963.7 963.7"}};

module.exports = IcX;

IcX.default = IcX;
